import React, { Fragment, useEffect, useState } from "react";

import { logoutHandler } from "../../utils/user/user";
import { useStore } from "../../hook-store/store";
import { NODEURL } from "../../App";

const AuthCheck = (props) => {
  // const { } = props;

  const [store, dispatch] = useStore();

  const [authCheckStart, setAuthCheckStart] = useState(false);

  useEffect(() => {
    if (!authCheckStart) {
      setAuthCheckStart(true);

      if (localStorage.getItem('token')) {
        authCheck();
      }
      
      setInterval(() => {
        // console.log('in setInterval')
        // console.log('lsToken', localStorage.getItem('token'));
        if (localStorage.getItem('token')) {
          authCheck();
        }
      }, 1000 * 60 * 60);
    }

  }, []);

  const authCheck = () => {
    //// check auth validity and logout
      fetch(NODEURL + "/auth/auth-check", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          console.log(res);
  
          //// logout when invalid auth
          if (res.status === 401) {

            dispatch('SET_ISAUTH', false);
            logoutHandler();
          }
          if (res.status !== 200) {
            throw new Error("Failed to fetch user status.");
          }
          return res.json();
        })
        .then((resData) => {
          console.log(resData);
          dispatch('SET_ISAUTH', true);
        })
        .catch((err) => {
          console.log(err);
        });
    
  };

  return <Fragment></Fragment>;
};

export default AuthCheck;
